module.exports = __webpack_public_path__ + "static/media/LI.2cbfe4a4.svg";